var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('HomePage'),(!_vm.isServiceProvider && !_vm.isAdmin)?_c('FeaturedTurf'):_vm._e(),_c('FrequentlyAskedQuestions'),_c('AboutPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }